import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';

const SimpleJudgeRow = ({ judge, group }) => {
  return (
    <>
      <div className='min-w-44'>{judge.name}</div>
      <div>{group ?? ''}</div>
      <Link to={`/judge-view/${judge._id}/all`}>
        <Button variant='contained' color='primary' size='small'>
          Start
        </Button>
      </Link>
    </>
  );
};

export default SimpleJudgeRow;
